import React, { useState } from 'react';
import { Typography, Button, Divider, Snackbar } from '@mui/material';
import { Form } from 'react-bootstrap';
// import worldmap from '../img/world_map.jpg';
// import whareHouse from '../img/whare_house.jpg';
// import stocks from '../img/stocks.jpg';
import { useNavigate } from 'react-router';
import LoginService from '../../Services/login/LoginService';
import { setloginPointIdSession, setloginSession, setUserName, setUserPlaceSession,setUserTypeSession } from '../Utils/Common';
import MuiAlert from '@mui/material/Alert';
// import AuthenticationService from '../../Services/AuthenticationService';
// import CryptoJS from 'crypto-js';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import ngpicon from '../../component/img/scope_logo.png'
import { useEffect } from 'react';
import { PropagateLoader } from 'react-spinners';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const LoginPage = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('')
  const handleClose = (event, reason) => {
    setOpen(false);
  };
  const [loading, setloading] = useState(false)

  const [severity, setseverity] = useState('');
  const [values, setValues] = useState({ username: '', password: '' });
  const [error, setErrors] = useState({ username: false, password: false });
  const [Valid, setValid] = useState({ username: false, password: false });
  const [proccessing, setProccessing] = useState(false);

  const userenter = (e) => {
    if (e.key === 'Enter') {
      document.getElementById('password').focus();
    }
  }
  const passwordenter = (e) => {
    if (e.key === 'Enter') {
      loginApi();
    }
  }

  //Authntication call request
  // const loginPage = (e) => {
  //   e.preventDefault();
  //   // setOpen(true);
  //   setProccessing(true);

  //   // Call Authentication service
  //   AuthenticationService.executeJwtAuthenticationService().then((response) => {
  //     console.log('APILogin=>' + JSON.stringify("Barear " + response.data.token));
  //     setUserSession("Bearer " + response.data.token, values.username)
  //     // setUserSession("Bearer ", values.txt_userName)
  //     // AuthenticationService.registerSuccessfulLoginForJwt(values.txt_userName,response.data.token);
  //     loginApi();

  //   }).catch(error => {
  //     console.log('catch auth  =>' + JSON.stringify(error.message));
  //     setProccessing(false);
  //     setseverity('error'); setErrors({ ...error, username: true, password: true });
  //     setMessage(error.message);
  //     setOpen(true); reset();
  //   });
  // }

  const loginApi = () => {
    if (values.username === '' || !values.username) {
      setErrors({ ...error, username: true });
      setseverity('warning')
      setMessage('UserName is Missing/Empty');
      setOpen(true);
      document.getElementById('user').focus();
    } else {
      if (values.password === '' || !values.password) {
        setErrors({ ...error, password: true });
        setseverity('warning')
        setMessage('Password is Missing/Empty');
        setOpen(true); document.getElementById('password').focus();
      } else {
        setProccessing(true);
        // const usernameencrypt = CryptoJS.AES.encrypt(values.username, "iyyapan").toString();
        // const psswordecrypt = CryptoJS.AES.encrypt(values.password, "iyyapan").toString();
        //   console.log('fjyg '+data)
        let details = { userName: values.username, password: values.password }
        LoginService.Login(details).then((res) => {
          const data = res.data; setProccessing(false);
          console.log('datas==>'+JSON.stringify(data[0]))
          if (data[0].message === 'SUCCESS') {
            setseverity('success')
            setMessage(data.message);
            setOpen(true);
            setloginSession(data[0].userId, data[0].currentDate)
            setloginPointIdSession(data[0].pointId)
            setUserPlaceSession(data[0].placeName); setUserTypeSession(data[0].userType)
            setUserName(data[0].userName)
            navigate('/home');
          } else {
            setseverity('error')
            setMessage(data[0].message.toString());
            setOpen(true); setErrors({ ...error, username: true, password: true });
          }
          reset();
        }).catch(error => {
          setProccessing(false);
          setseverity('error'); setErrors({ ...error, username: true, password: true });
          setMessage(error.message);
          setOpen(true); reset();
        })
      }
    }

  }

  const reset = () => {
    setValues({ ...values, username: '', password: '' });
    document.getElementById('user').focus();
  }

  const UserChangehanlde = (e) => {
    setValues({ ...values, username: e.target.value });
    if (!e.target.value || e.target.value === '') {
      setErrors({ ...error, username: true });
      setValid({ ...Valid, username: false });
    } else {
      setErrors({ ...error, username: false });
      setValid({ ...Valid, username: true });
    }
  }

  const PasswordChangehanlde = (e) => {
    setValues({ ...values, password: e.target.value });
    if (!e.target.value) {
      setErrors({ ...error, password: true });
      setValid({ ...Valid, password: false });
    } else {
      setErrors({ ...error, password: false });
      setValid({ ...Valid, password: true });
    }
  }

  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 2500)
  }, [])
  return (
    <div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }} TransitionComponent={'TransitionRight'}>
        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
     
      {loading ?
        <div className="loaderCss2">
          <PropagateLoader
            color={"#db8d10"}
            loading={loading}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
        :
        <div className='loginBodyImage'>
          <div className='loginBody'>
            <Grid2>
              <div className='ngploginicon'><img src={ngpicon} alt="Logo" style={{ width: '100%' }} /></div>
              <Divider /><Divider />
              <br></br>
              <center><Typography className='welcom2'>Login to Continue...</Typography></center>
              <div className='urnamepasswdBody'>
                <div>
                  <Form.Label className='usrnmpswrd'>User Name</Form.Label>
                  <center><Form.Control className='logintextBox' id='user' autoFocus style={{ textAlign: 'center' }} required value={values.username} autoComplete='off'
                    onChange={UserChangehanlde} isInvalid={error.username} placeholder="Enter your UserName..." isValid={Valid.username} onKeyDown={userenter} /></center>
                </div>
                <div>
                  <Form.Label className='usrnmpswrd mt-2'>Password</Form.Label> 
                  <center><Form.Control className='logintextBox' id='password' style={{ textAlign: 'center' }} type='password' value={values.password} autoComplete='off'
                    onChange={PasswordChangehanlde} isInvalid={error.password} placeholder="Enter your password..." isValid={Valid.password} onKeyDown={passwordenter} /></center>
                </div>
                <div className='mt-2'>
                  <center><Button className='loginBtn' id='login' variant='contained' color='warning' onClick={loginApi}>{proccessing ? 'processing..' : 'Login'}</Button></center>
                </div>
              </div>
            </Grid2>
          </div>
        </div>}
    </div>
  );
};

export default LoginPage;
